import React, { lazy } from 'react'
import { LazyRoute } from 'Modules'
import { FrontUrls } from 'Constants/FrontUrls'
import { Switch } from 'react-router-dom'

const UsersLogsComponentLazy = lazy(() => import('Pages/logs/users/components/List'))

export const UsersLogsRoutes = () => {
	return (
		<Switch>
			<LazyRoute
				exact
				path={FrontUrls.logs.users}
				lazyComponent={UsersLogsComponentLazy}
				key={FrontUrls.logs.users}
			/>
		</Switch>
	)
}
